import script from "./Krediflow-Settings-Channels.vue?vue&type=script&setup=true&lang=js"
export * from "./Krediflow-Settings-Channels.vue?vue&type=script&setup=true&lang=js"

import "./Krediflow-Settings-Channels.vue?vue&type=style&index=0&id=51100a64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51100a64"]])

export default __exports__